import NumberFormat from "react-number-format";
import React from "react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

export const isPdf = (url) => {
  const extension = url.split(".").pop().toLowerCase();
  if (extension === "pdf") {
    return true;
  } else {
    return false;
  }
};

export function getFormattedIntake(dateString) {
  const date = dayjs(dateString, "YYYY-MM-DD HH:mm:ss");
  return date.format("MMM YYYY");
}

export function reformatFilters(filters) {
  const reformattedFilters = {};

  for (const key in filters) {
    if (filters.hasOwnProperty(key)) {
      const [min, max] = filters[key];
      reformattedFilters[`min${key.charAt(0).toUpperCase() + key.slice(1)}`] =
        min;
      reformattedFilters[`max${key.charAt(0).toUpperCase() + key.slice(1)}`] =
        max;
    }
  }

  return reformattedFilters;
}

export function formatDate(json) {
  const { date, time } = json;

  const dateTime = new Date(
    date.year,
    date.month - 1,
    date.day,
    time.hour,
    time.minute,
    time.second
  );

  // Format the date-time string using the built-in toLocaleString() method
  const formattedDateTime = dateTime.toLocaleString();

  return formattedDateTime;
}

export function reverseReformatFilters(reformattedFilters) {
  const filters = {};

  for (const key in reformattedFilters) {
    if (reformattedFilters.hasOwnProperty(key)) {
      const originalKey = key.replace(/^min|^max/, "");
      const lowerOriginalKey =
        originalKey.charAt(0).toLowerCase() + originalKey.slice(1);

      if (!filters[lowerOriginalKey]) {
        filters[lowerOriginalKey] = [];
      }

      if (key.startsWith("min")) {
        filters[lowerOriginalKey][0] = reformattedFilters[key];
      } else if (key.startsWith("max")) {
        filters[lowerOriginalKey][1] = reformattedFilters[key];
      }
    }
  }

  return filters;
}

export function changeTitle(title) {
  // Change document title
  if (title) {
    document.title = title;
  }
}

export function convertIntakesDates(intakes) {
  return intakes.map((intake) => {
    console.log(intake);
    const startDateTime = new Date(
      intake.startDate.date.year,
      intake.startDate.date.month - 1, // JavaScript months are zero-based, so we subtract 1
      intake.startDate.date.day,
      intake.startDate.time.hour,
      intake.startDate.time.minute,
      intake.startDate.time.second
    );

    const endDateTime = new Date(
      intake.endDate.date.year,
      intake.endDate.date.month - 1, // JavaScript months are zero-based, so we subtract 1
      intake.endDate.date.day,
      intake.endDate.time.hour,
      intake.endDate.time.minute,
      intake.endDate.time.second
    );

    return {
      ...intake,
      startDate: startDateTime,
      endDate: endDateTime,
    };
  });
}

export const PriceAmount = ({ amount, currency }) => {
  return (
    <NumberFormat
      displayType="text"
      value={(Math.round(amount * 100) / 100).toFixed(2)}
      prefix={`${currency === "GBP" ? "£" : "$"} `}
      thousandSeparator={true}
    />
  );
};

export function convertToYearsOrMonths(value) {
  const years = Math.floor(value);
  const months = Math.round((value - years) * 12);

  if (years > 0 && months > 0) {
    return `${years} years, ${months} months`;
  } else if (years > 0) {
    return `${years} years`;
  } else if (months > 0) {
    return `${months} months`;
  } else {
    return "0 months";
  }
}

export function changeFavicon(url) {
  console.log("url", url);
  const link = document.querySelector("link[rel~='icon']");
  if (link) {
    link.href = url;
  } else {
    const newLink = document.createElement("link");
    newLink.rel = "icon";
    newLink.href = url;
    document.head.appendChild(newLink);
  }
}

export function getElementsWithAttenuationLevelOne(arr) {
  const names = [];
  for (let i = 0; i < arr.length; i++) {
    console.log(arr[i]);
    if (arr[i].attentionLevel === 1) {
      names.push(arr[i].attachmentType);
    }
  }
  return names.join(", ");
}

export const normalizeUrl = (url) => {
  if (!url) return "#";
  return url.startsWith("http://") || url.startsWith("https://")
    ? url
    : `https://${url}`;
};

export function getMetaParams() {
  const params = new URLSearchParams(window.location.search);
  const fbclid = params.get("fbclid");
  const fbc =
    getCookie("_fbc") ||
    (fbclid ? "fb.1." + Date.now() + "." + fbclid : null);
  const fbp = getCookie("_fbp");
  return { fbc, fbp, fbclid };
}

function getCookie(name) {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
}

// The IP only annotates sign-ups and form leads, so a blocked or slow lookup must never hold them up.
const IP_LOOKUP_TIMEOUT_MS = 3000;

export async function getClientIp() {
  const lookup = fetch("https://api.ipify.org/?format=json")
    .then((res) => res.json())
    .then((data) => data.ip || "")
    .catch(() => "");
  const timeout = new Promise((resolve) => setTimeout(() => resolve(""), IP_LOOKUP_TIMEOUT_MS));
  return Promise.race([lookup, timeout]);
}

export const trackLeadEvent = (email) => {
  try {
    if (window.fbq) {
      const payload = email
        ? {
            // Advanced Matching
            em: email,
          }
        : {};

      window.fbq("track", "Lead", payload);
      console.log("[Meta Pixel] Lead event triggered", payload);
    } else {
      console.warn("[Meta Pixel] fbq not loaded");
    }
  } catch (err) {
    console.error("Failed to track Meta Pixel Lead event:", err);
  }
};
